import { RootState } from "common/reducers";

const rootKey = "orgs";

/**
 * Loads byId key from orgs
 *
 * @param {RootState} state The RootState
 * @param {{}} options
 * @returns {Map<number, OrgRecord>} Map<number, OrgRecord>
 */
export const byId = (state: RootState) => state.getIn([rootKey, "byId"]);

/**
 * Loads currentOrgId key from orgs
 *
 * @param {RootState} state The RootState
 * @param {{}} options
 * @returns {number} number
 */
export const currentOrgId = (state: RootState) => state.getIn([rootKey, "currentOrgId"]);
